const E_AUTH_PATHS = {
  SIGN_UP: "/auth/sign-up",
  SIGN_IN: "/auth/sign-in",
  SEND_OTP_PHONE: "/auth/send-otp-by-phone",

  FORGOT_PASSWORD: "users/forgot-password",
  VERIFICATION_TOKEN: "/users/forgot-password/verify",
  RESET_PASSWORD: "/users/new-password",
  VERIFY_OTP: "/auth/verify-otp",
  ADMIN_SIGNIN_AGENT: "/auth/sign-in-agent/by-admin",
  SIGN_OUT: "/auth/sign-out",
  VERIFY_RECAPTCHA: "/auth/verify-recaptcha",
};

export default E_AUTH_PATHS;
